let prevScrollPos = window.pageYOffset;
const navbar = document.querySelector('.nav_contain');
let ticking = false;

// Scroll event listener for navbar
if (navbar) {
    window.addEventListener("scroll", function () {
        if (!ticking) {
            requestAnimationFrame(() => {
                let currentScrollPos = window.pageYOffset;
                
                if (prevScrollPos > currentScrollPos) {
                    navbar.style.setProperty('--nav-position', '0'); // Show navbar
                } else {
                    navbar.style.setProperty('--nav-position', '-112px'); // Hide navbar
                }

                prevScrollPos = currentScrollPos;
                ticking = false;
            });
            ticking = true;
        }
    });
}

// DOMContentLoaded event listener for category dropdown
document.addEventListener("DOMContentLoaded", function () {
    const categoryDataDiv = document.getElementById("category-data");
    const categorySelect = document.getElementById("category-select");

    if (categoryDataDiv && categorySelect) {
        // Parse category JSON data
        const categories = JSON.parse(categoryDataDiv.getAttribute("data-categories") || "[]");

        // Populate the select dropdown
        categories.forEach(category => {
            const option = document.createElement("option");
            option.value = category.id;
            option.textContent = category.name;
            categorySelect.appendChild(option);
        });

        // Handle category selection
        categorySelect.addEventListener("change", function (e) {
            const selectedCategoryId = e.target.value;
            if (!selectedCategoryId) return;

            // Find the selected category object
            const selectedCategory = categories.find(category => category.id == selectedCategoryId);

            // Redirect to the category archive page
            if (selectedCategory && selectedCategory.link) {
                window.location.href = selectedCategory.link;
            }
        });
    }
});

// Burger menu toggle
const burger = document.getElementById("burger");
if (burger) {
    burger.addEventListener("click", function() {
        const menu = document.querySelector(".nav_contain_content_small");
        if (menu) {
            menu.style.display = menu.style.display === "flex" ? "none" : "flex";
        }
    });
}

// Search functionality
document.addEventListener("DOMContentLoaded", function () {
    const searchInput = document.getElementById("search-input");
    const searchResults = document.getElementById("search_results");
    const searchIcon = document.getElementById("search-icon");

    if (searchIcon) {
        searchIcon.addEventListener('click', () => {
            // Get the current value of --nav-search-input-opacity
            let currentOpacity = getComputedStyle(document.documentElement).getPropertyValue('--nav-search-input-opacity').trim();
        
            // Toggle between 0 and 1 opacity (visible/invisible)
            if (currentOpacity === '0') {
                document.documentElement.style.setProperty('--nav-search-input', 'block');
                document.documentElement.style.setProperty('--nav-search-input-width', '300px');
                document.documentElement.style.setProperty('--nav-search-input-opacity', '1');
                // document.documentElement.style.setProperty('--search-input-left-icon', 'calc(-26vw)');
                document.documentElement.style.setProperty('--search-input-left', '0');
                document.documentElement.style.setProperty('--search-display', 'block');
            } else {
                document.documentElement.style.setProperty('--nav-search-input-opacity', '0');
                document.documentElement.style.setProperty('--nav-search-input-width', '0px');
                // document.documentElement.style.setProperty('--search-input-left-icon', '-20px');
                // document.documentElement.style.setProperty('--search-input-left', 'calc(100vw + 32px)'); 
                document.documentElement.style.setProperty('--nav-search-input', 'none');
                document.documentElement.style.setProperty('--search-display', 'none');
            }
        });
    }

    if (searchInput && searchResults) {
        searchInput.addEventListener("input", async function () {
            const query = searchInput.value.trim();
            
            if (query.length === 0) {
                searchResults.innerHTML = "";
                return;
            }

            try {
                const response = await fetch(`${searchData.rest_url}?search=${query}`, {
                    method: 'GET',
                    headers: {
                        'X-WP-Nonce': searchData.nonce,  // Include the nonce for security
                    }
                });

                const posts = await response.json();

                let resultsHTML = "";
                posts.forEach(post => {
                    console.log(post)
                    resultsHTML += `<div><a href="${post.link}">${post.title.rendered}</a></div>`;
                });
                searchResults.innerHTML = resultsHTML;
            } catch (error) {
                console.error('Error fetching search results:', error);
            }
        });
    }
});